import firebase from "firebase/app"
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/storage'

//import VueJWT from './plugins/vue-jwt'

//import 'firebase/admin-auth'

//Configuring de app
//https://savvyapps.com/blog/definitive-guide-building-web-app-vuejs-firebase
// Your web app's Firebase configuration
//var tempToken = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJCYXJiZWFyaWEiLCJpYXQiOjE2MDEzOTUzMzYsImV4cCI6MTY3NDg2OTc3MzYsImF1ZCI6Ind3dy5iYXJiZWFyaWFsaXNib2EuY29tLmJyIiwic3ViIjoiZG91Z2xhcyIsImFwaUtleSI6IkFJemFTeUM5aXF4OFRWU1l2dnJhUDdpWVF4TmdGOWpaWmM5VWo1NCIsImF1dGhEb21haW4iOiJpbnN0YWRvZy0yOTA4Yi5maXJlYmFzZWFwcC5jb20iLCJwcm9qZWN0SWQiOiJpbnN0YWRvZy0yOTA4YiIsInN0b3JhZ2VCdWNrZXQiOiJpbnN0YWRvZy0yOTA4Yi5hcHBzcG90LmNvbSIsIm1lc3NhZ2luZ1NlbmRlcklkIjoiNjY5OTU5NjkzNjI2IiwiYXBwSWQiOiIxOjY2OTk1OTY5MzYyNjp3ZWI6ODk4OWRiY2M4MzlhMDRjN2VjOWMwMyIsImRhdGFiYXNlVVJMIjoiaHR0cHM6Ly9pbnN0YWRvZy0yOTA4Yi5maXJlYmFzZWlvLmNvbSJ9.GruKJpHAR7X5pq09pg7xIH5Ojvi6m3M7X0jbDVe8Bzc'

//console.log(VueJWT);
//let config = VueJWT.decode(tempToken)
//  var firebaseConfig = {
//     apiKey: "AIzaSyC9iqx8TVSYvvraP7iYQxNgF9jZZc9Uj54",
//     authDomain: "instadog-2908b.firebaseapp.com",
//     databaseURL: "https://instadog-2908b.firebaseio.com",
//     projectId: "instadog-2908b",
//     storageBucket: "instadog-2908b.appspot.com",
//     messagingSenderId: "669959693626",
//     appId: "1:669959693626:web:8989dbcc839a04c7ec9c03"
//   };


const firebaseConfig = {
  apiKey: "AIzaSyCO7uv4CfFRocLmuSIJ9TU_jQE4XABquA0",
  authDomain: "barbearialisboafinal.firebaseapp.com",
  databaseURL: "https://barbearialisboafinal.firebaseio.com",
  projectId: "barbearialisboafinal",
  storageBucket: "barbearialisboafinal.appspot.com",
  messagingSenderId: "982325657676",
  appId: "1:982325657676:web:7c6f37d7cdc4971dc8f4e9",
  measurementId: "G-M2YY42MBZF"
};
 
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
  
  //iniciar FIRESTORE
  export const db = firebase.firestore();
  export const auth = firebase.auth();

  if (process.env.VUE_APP_USE_FIREBASE_EMULATORS === 'true') {
    db.settings({
      host: process.env.VUE_APP_FIRESTORE_EMULATOR_HOST || '127.0.0.1:8080',
      ssl: false
    });
  }

  
  // collection references
export const refAgenda = db.collection('agenda')
export const refBarbeiros = db.collection('barbeiros')
export const refFuncoes = db.collection('funcoes')
export const refFeriados = db.collection('feriados')
export const refUsers = db.collection('users-temp')
export const refMensagens = db.collection('mensagens')
export const refFotos = db.collection('fotos')
export const refSessoes = db.collection('sessoes')
export const refConfiguracoes = db.collection('configuracoes')
export const storageRef = firebase.storage()


 //export default {db, auth};
  
